import React from 'react';
//styles and icons 
import { Paper, Chip } from '@material-ui/core';
import { Row, Col } from 'react-bootstrap';
import SpecIcon from '../../../images/speciality.svg';

// this component represent the profile speciality part in explore opportunities page 
export default function Speciality(props) {
    let specialities = props.data;
    return (
        <>
            <main className="speciality mt-4">
                <Paper className="p-3" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                    <Row >
                        <Col md={12}>
                            <Row className="m-0 mb-3 align-items-center">
                                <Col className="text-left p-0">
                                    <h6 className="bold mb-0">
                                        <span className="pr-3"><img src={SpecIcon} alt="icon" /></span
                                        >Specialties</h6>
                                </Col>
                            </Row>
                            <Row className="m-0">
                                <Col className="p-0">
                                    {(specialities) ?
                                        specialities.map(speciality =>
                                            <div key={speciality.id} className="speciality-tags d-inline-block"> 
                                                <Chip
                                                    label={speciality.name}
                                                    className=" m-1"
                                                />
                                            </div>) : ''}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Paper>
            </main>
        </>
    )
}

